<template>
  <b-nav-item-dropdown class="notifications" right :class="showNotifications ? 'show' : ''">
    <template v-slot:button-content>
      <BellIcon
        title="Notificações"
        :size="18"
        :class="notificationsNotRead ? 'notifications-not-read' : ''"
      ></BellIcon>
    </template>
    <b-dropdown-header>
      Notificações
      <span class="quantity">{{ notificationsNotRead }}</span>
    </b-dropdown-header>

    <b-dropdown-group>
      <b-dropdown-item-button
        v-for="notification in notifications"
        :key="notification.id"
        :class="notification.readed ? 'readed' : ''"
        @click.stop="handleMarkRead(notification)"
      >
        <div class="container-row">
          <div class="content" v-html="notification.content"></div>
          <button>
            <CheckboxChecked :size="16" v-if="notification.readed"></CheckboxChecked>
            <Checkbox :size="16" v-else></Checkbox>
          </button>
        </div>
        <div class="date">
          <Clock :size="16" title="Data"></Clock>
          {{ notification.created | moment('DD/MM/YYYY') }}
        </div>
      </b-dropdown-item-button>
    </b-dropdown-group>

    <b-dropdown-item href="/#/notification/" class="all">
      Todas as Notificações
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import BellIcon from 'vue-material-design-icons/Bell';
import Checkbox from 'vue-material-design-icons/CheckboxBlankOutline';
import Clock from 'vue-material-design-icons/ClockOutline';
import CheckboxChecked from 'vue-material-design-icons/CheckBoxOutline';
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import { connectSocket } from '../../configurations/webSocket';

export default {
  components: {
    BellIcon,
    CheckboxChecked,
    Checkbox,
    Clock,
  },
  props: ['showNotifications', 'handleShowNotifications'],
  data() {
    return {
      event: null,
      notifications: [],
    };
  },
  name: 'NavbarNotifications',
  computed: {
    ...mapState('user', ['user']),

    notificationsNotRead() {
      return this.notifications.filter(({ readed }) => !readed).length;
    },
  },
  async mounted() {
    this.getNotifications();
    await this.connectSocket();
  },
  methods: {
    ...mapActions('user', ['setUser']),

    async connectSocket() {
      await this.setUser();

      const socket = connectSocket();
      socket.on('notification', (data) => {
        this.notifications = [
          {
            id: data.id,
            content: data.content,
            created: moment().calendar(),
          },
          ...this.notifications,
        ];
      });

      socket.on('error', (error) => {
        console.error(error);
      });
    },
    formatNotifications(notifications) {
      return notifications.map((e) => ({
        ...e,
        originalCreated: e.created,
        created: moment(e.created).calendar(),
      }));
    },
    async getNotifications() {
      try {
        const { data: notifications } = await this.$http.get(
          'application.get-latest_messages-user',
        );

        this.notifications = this.formatNotifications(notifications);
      } catch (error) {
        this.notifications = [];
      }
    },
    handleMarkRead(notification) {
      const { id: notificationId, readed } = notification;
      this.handleShowNotifications(true);
      this.event = () => {
        this.handleShowNotifications(false);
        document.removeEventListener('click', this.event);
      };

      document.addEventListener('click', this.event);

      if (!readed) {
        this.markAsReaded(notificationId);
      }

      return notificationId;
    },
    async markAsReaded(notificationId) {
      try {
        await this.$http.post('application.mark-message-as-readed', {
          id: notificationId,
        });

        await this.getNotifications();

        return true;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.material-design-icon {
  font-size: 16px;
}
</style>
